import type { FormFile } from '../../types/form/form-fields/field-values';

export const sortFilesByCreationDate: (a: FormFile, b: FormFile) => number = (
	a: FormFile,
	b: FormFile,
) => (b.creationDate && a.creationDate ? b.creationDate - a.creationDate : 0);
